const la_mas_heavy = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_PRINCIPAL",
        "tarifa": {
            "id": "PPOSCONVERGENTAVATEL5",
            "price": 53.7024,
            "name": "Heavy - 1 GB + 100 GB",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": "",
            "commercial_enrichment": "",
            "description_file": "",
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": {
                "mobile_line_data": {
                    "unit": "GB",
                    "amount": 0
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-11-28T01:24:48.690243+01:00",
            "updated_on": "2022-12-05T14:03:42.400536+01:00",
            "svas": [],
            "promotions": [
                "PROMOAVATEL",
                "PROMOAVATEL1"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOAVATEL",
                "duration": 3,
                "name": "Sin Permanencia",
                "duration_unit": "month",
                "amount": "5.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "AVATEL"
            }
        ]
    },
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PCOMAVATEL",
            "price": 0,
            "max_number": 0,
            "mobile_line_info": {
                "price": {
                    "base_fee": "0.0000"
                },
                "mobile_line_data": {
                    "unit": "",
                    "amount": ""
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": ""
                }
            },
            "name": "Comparte",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T18:04:53.984964+01:00",
            "updated_on": "2022-11-24T18:04:53.985002+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PCOMAVATEL",
            "price": 0,
            "max_number": 0,
            "mobile_line_info": {
                "price": {
                    "base_fee": "0.0000"
                },
                "mobile_line_data": {
                    "unit": "",
                    "amount": ""
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": ""
                }
            },
            "name": "Comparte",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T18:04:53.984964+01:00",
            "updated_on": "2022-11-24T18:04:53.985002+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "WIFI_6AVATEL",
            "price": 4.1239,
            "name": "WiFi 6",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T17:55:20.164020+01:00",
            "updated_on": "2022-11-24T17:55:20.164048+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "MAS_CLICTV_+_DAZN_TOTALAVATEL",
            "price": 24.7934,
            "name": "Más CLICtv + DAZN Total",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T18:34:43.381541+01:00",
            "updated_on": "2022-11-30T16:54:45.183738+01:00",
            "promotions": [
                "PROMOAVATEL3",
                "PROMOAVATEL4",
                "PROMOAVATEL7",
                "PROMOAVATEL5"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOAVATEL4",
                "duration": -1,
                "name": "Dazn Total & La más Heavy 1GB",
                "duration_unit": "month",
                "amount": "15.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "AVATEL"
            }
        ]
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "DECODIFICADOR_PRINCIPAL_MAS_CLICTVAVATEL",
            "price": 2.4793,
            "name": "Decodificador principal Más CLICtv",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T17:54:13.203468+01:00",
            "updated_on": "2022-11-24T17:54:13.203493+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    }
]

export default la_mas_heavy;